import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import GridList from "@material-ui/core/GridList";
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import autoscroll from "autoscroll-react";
import PropTypes from "prop-types";
import React from "react";
import ReactMarkdown from "react-markdown";
import Avatar from '@material-ui/core/Avatar';
import SimpleRating from './components/SimpleRating';

import DesplegableDoble from "./components/DesplegableDoble"
import ReactPlayer from 'react-player'

import generate_response from "./multimedia/writing2.gif";
import perfil_bot from "./images/perfil_2.png"
import perfil_user from "./images/perfil.png"
import notificationBot from "./multimedia/notificationBot.mp3"
import notificacionUser from "./multimedia/notificationUser.mp3"

const videos = {}

const styles = theme => ({
  root: {
    overflowY: "auto",
    flex: 1,
    padding: "0.5em"
  },
  fullMessage: {
    display: "flex",
    fontSize: "0.9em",
    margin: "0.3em",
    maxWidth: "100%",
    marginRight: "1em",
    flexDirection: "column"
  },
  messageBlock: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "20px"
  },
  optionsContainer: {
    marginLeft: "60px",
    marginBottom: "18px",
    flexWrap: "wrap",
    justifyContent: "space-evenly"
  },
  messageBubble: {
    flexDirection: "row",
    overflow: "hidden",
    alignItems: "flex-end",
    boxShadow: "none",
    padding: "10px 15px",
    "& ol": {
      paddingLeft: "0px"
    },
    "& ul": {
      margin: "5px 0 0 0",
      paddingLeft: "2.72rem"
    }
  },
  messageText: {
    whiteSpace: "pre-line",
    overflowWrap: "break-word",
    fontFamily: "'Lato',sans-serif",
    fontSize: "1.5rem",
    wordWrap: "break-word",
    maxWidth: "250px",
    textAlign: "left",
    "& p": {
      margin: 0,
      paddingBottom: 0
    },
    "& a": {
      color: "#0645AD",
      textDecoration: "none",
      "&:visited": {
        color: "#800080",
      },
      "&:hover": {
        color: "#3366BB",
        textDecoration: "underline",
      },
    },

    "& li": {
      marginBottom: "0.4em"
    },
    "& ul": {
      whiteSpace: "normal"
    }
  },
  messageWarning: {
    whiteSpace: "pre-line",
    overflowWrap: "break-word",
    fontFamily: "'Lato',sans-serif",
    fontSize: "1.5rem",
    wordWrap: "break-word",
    maxWidth: "260px",
    textAlign: "justify",
    "& p": {
      margin: 0,
      paddingBottom: "0.5rem"
    },
  },
  date: {
    fontFamily: "'Lato',sans-serif",
    margin: "10px 5px",
    fontSize: "1.1rem",
    fontStyle: "italic",
    textAlign: "right",
    paddingBottom: 0,
    "& p": {
      margin: 0,
      paddingBottom: 0
    },
  },
  imageContainer: {
    width: "100%"
  },
  card: {
    maxWidth: 345,
    minWidth: 200
  },
  cardSize: {
    height: 210,
    backgroundColor: "#f8f8f8",
    display: "flex",
    flexDirection: "column"
  },
  cardContent: {
    whiteSpace: "pre-line",
    overflowWrap: "break-word",
    paddingTop: "0.7em",
    paddingBottom: "0",
    height: "100%",
    flex: 1
  },
  media: {
    height: 140
  },
  slider: {
    display: "flex",
    flexWrap: "wrap",
    padding: 4,
    justifyContent: "space-around",
    overflow: "hidden",
    width: "auto",
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    flexWrap: "nowrap",
    paddingLeft: 4,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)"
  },
  cardActionArea: {
    flex: 1
  },
  cardButtons: {
    flex: 0
  },
  cardText: {
    marginBottom: 0,
    "& a": {
      color: theme.palette.primary.main
    },
    "& li": {
      marginBottom: "0.4em"
    }
  },
  button: {
    maxWidth: "283px",
    width: "100%",
    minHeight: "40px",
    margin: "2px 0 9px 0",
    fontFamily: "'Lato',sans-serif",
    fontSize: "1.28rem",
    lineHeight: "1.3em",
    borderRadius: "4px",
    textAlign: "Left",
    justifyContent: "start",
    padding: "8px 15px"
  },
  buttonWelcome: {
    maxWidth: "276px",
    width: "100%",
    margin: "2px 0 2px 0",
    fontFamily: "'Lato',sans-serif",
    fontSize: "1.28rem",
    lineHeight: "1.3em",
    borderRadius: "4px",
    textAlign: "Left",
    justifyContent: "start"
  },
  IBMCard: {
    fontFamily: "Helvetica",
    width: "90%",
    marginLeft: "1em"
  },
  IBMCardTitle: {
    padding: "10px",
    fontSize: "1.3rem"
  },
  IBMCardSubtitle: {
    padding: "11px",
    marginTop: "-1.2em"
  },
  messageBubbleGenerate: {
    marginTop: "3px",
    marginLeft: "5px",
    boxShadow: "0px 0px 0px 0px"
  },
  generateResponse: {
    width: "4rem",
    padding: "5px"
  },
  perfil: {
    margin: "10px"
  }
});

class MyList extends React.Component {
  buttonClick(event) {
    this.props.onButtonClick(event.target.textContent);
  }
  minimize = (m) => {
    this.props.minimize();
  }

  postbackButtonClick(event) {
    this.props.onPostbackButtonClick(event);
  }

  disambiguationIBMButtonClick(event) {
    this.props.onDisambiguationIBMButtonClick(event);
  }

  buttonDesplegableClick(event) {
    this.props.eventButtonClick({ "payload": event.payload, "text": event.text_label });
    this.messagesEnd.scrollIntoView({ behavior: "smooth", inline: "end" });
  }



  options = (message, index) => {
    if (message.type === "quick_replies") {
      return this.quickReplies(message.data);
    } else if (message.type === "text_button") {
      return this.textButtons(message.data);
    } else if (message.type === "postback_button") {
      if (!message.disabled) {
        if (this.props.primera_vez) {
          return this.postbackButtonsWelcome(message.data)
        }
        else {
          return this.postbackButtons(message.data)
        };
      }
    } else if (message.type === "disambiguationIBM") {
      return this.disambiguationIBMButtons(message.data);
    } else if (message.type === "phone_button") {
      return this.phoneButton(message.data);
    } else if (message.type === "text_card") {
      return this.mountSlider(message.data);
      //  else if (message.type === "image_card") {
      //   return (
      //     <DynamicCoberturasCard
      //       data={message.buttons}
      //       submitForm={this.submitForm.bind(this)}
      //     />
      //   );
    } else if (message.type === "event_button") {
      return this.eventButtons(message.data);
    } else if (message.type === "double_dropdown") {
      return (
        <DesplegableDoble
          data={message.data}
          onButtonClick={this.buttonDesplegableClick.bind(this)}
        />
      );
    } else if (message.type === "text_video") {
      return this.showVideo(message)
    } else if (message.type === "image") {
      return this.showImage(message);
    } else if (message.type === "IBM_image") {
      return this.showIBMImage(message);
    } else if (message.type === "rating") {
      return this.showRating(message, index);
    } else if (message.type === "warning") {
      return this.showWarning(message);
    } else {
      return null;
    }
  };

  textButtons = message => {
    const { classes } = this.props;
    return message.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <Button role="button"

          key={key}
          className={classes.button}
          color="primary"
          variant="outlined"
          onClick={this.buttonClick.bind(this)}
        >
          {m.text}
        </Button>
      );
    });
  };

  postbackButtons = message => {
    const { classes } = this.props;
    return message.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <Button
          className={classes.button}
          color="secondary"
          key={key}
          onClick={() => this.postbackButtonClick(m)}
          title={m.text}
          variant="outlined"
        >
          {m.text}
        </Button>
      );
    });
  };

  postbackButtonsWelcome = message => {
    const { classes } = this.props;
    return message.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <Button
          className={classes.button}
          color="secondary"
          key={key}
          onClick={() => this.postbackButtonClick(m)}
          style={{ padding: "30px 15px", justifyContent: "center", fontSize: "1.7rem", margin: "10px 0 10px 0" }}
          title={m.text}
          variant="outlined"
        >
          {m.text}
        </Button>
      );
    });
  };

  eventButtons = message => {
    const { classes } = this.props;
    return message.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <Button role="button"
          key={key}
          className={classes.button}
          color="primary"
          variant="outlined"
          onClick={() => this.props.eventButtonClick(m)}
        >
          {m.text}
        </Button>
      );
    });
  };

  disambiguationIBMButtons = message => {
    const { classes } = this.props;
    return message.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <Button
          key={key}
          className={classes.button}
          color="secondary"
          variant="contained"
          onClick={() => this.disambiguationIBMButtonClick(m.payload)}
        >
          {m.text}
        </Button>
      );
    });
  };

  showImage = message => {
    const { classes } = this.props;
    return message.buttons.map(m => {
      const key = m.key + "_" + m.text;
      return (
        <div key={key}>
          <img className={classes.imageContainer} src={m.data} alt={m.text} />
        </div>
      );
    });
  };

  showVideo = message => {
    return message.data.map(v => {
      const identifier = v.id
      const key = message.key + "_" + v.id;
      return (
        <Paper key={key}>
          <ReactPlayer url={videos[identifier]}
            playing={false}
            loop={false}
            controls={true}
            width="340px"
            height="164px"
          />
        </Paper>
      )
    }
    )
  }

  showRating = (message, index) => {
    return (
      <SimpleRating
        send_rating={this.props.send_rating}
        number={message.key}
        aria-live="polite" tabIndex="0"
        defaultValue={message.rating ? message.rating : null}
        disabled = {message.rating ? true : false}
        index= {index}
      >
      </SimpleRating>
    )
  }

  showIBMImage = message => {
    const { classes } = this.props;
    return (
      <Paper className={classes.IBMCard}>
        <img className={classes.imageContainer} src={message.data.img} alt="IBMimage" />
        <Typography gutterBottom variant="h5" component="h2" className={classes.IBMCardTitle}>
          {message.data.title}
        </Typography>
        <Typography className={classes.IBMCardSubtitle} component="p">
          {message.data.description}
        </Typography>
      </Paper>
    );
  };

  mountSlider = message => {
    const { classes } = this.props;
    return (
      <div className={classes.slider}>
        <GridList
          className={classes.gridList}
          cols={2.5}
          cellHeight="auto"
          spacing={8}
        >
          {this.showCard(message)}
        </GridList>
      </div>
    );
  };

  showCard = message => {
    const { classes } = this.props;
    return message.map(m => {
      return (
        <div className={classes.card}>
          <Card className={classes.cardSize}>
            {/* <CardActionArea className={classes.cardActionArea}> */}
            <CardContent className={classes.cardContent}>
              <Typography gutterBottom variant="h6" component="h2">
                {m.title}
              </Typography>
              <Typography gutterBottom variant="subtitle2" component="h2">
                {m.subtitle}
              </Typography>
              <Typography
                style={{ whiteSpace: "pre-line", overflow: "auto" }}
                variant="p"
                color="textSecondary"
                component="p"
                noWrap={true}
              >
                <ReactMarkdown
                  className={classes.cardText}
                  source={m.text}
                  linkTarget="_blank"
                />
              </Typography>
            </CardContent>
            {/* </CardActionArea> */}
            <CardActions className={classes.cardButtons}>
              {this.postbackButtons(m.buttons)}
            </CardActions>
          </Card>
        </div>
      );
    });
  };

  phoneButton = message => {
    const { classes } = this.props;
    return message.buttons.map(m => {
      const key = message.key + "_" + m.text;
      return (
        <div key={key} className={classes.phoneContainer}>
          <Icon color="primary">phone</Icon>
          <Button
            className={classes.button}
            onClick={this.phoneClick.bind(this)}
            color="primary"
            variant="outlined"
          >
            {m.text}
          </Button>
        </div>
      );
    });
  };

  quickReplies = message => {
    const { classes } = this.props;
    return (
      <div className={classes.quickrepliesContainer}>
        {message.buttons.map(m => {
          return (
            <Button
              className={classes.quickReply}
              onClick={this.quickReplyClick.bind(this)}
              color="primary"
              size="small"
              variant="outlined"
            >
              {m.text}
            </Button>
          );
        })}
      </div>
    );
  };

  showWarning = message => {
    const { classes } = this.props;
    return message.data.map(m => {
      const key = m.key + "_" + m.text;
      return (
        <Paper
          key = {key}
          className={classes.messageBubble}
          style={{
            backgroundColor: "#ffcb77",
            color: "#001C30",
            borderRadius: 0,
            border: "1px solid #dee1e5",
            maxWidth: "283px"

          }}
        ><div aria-live="polite" tabIndex="0" role="log">
            <ReactMarkdown
              className={classes.messageWarning}
              style={{ textAlign: "justify", maxWidth: 300 }}
              children={m.text}
              components={{
                a: ({ node, ...props }) => <a {...props} aria-label={node.children[0].value} /> //
              }}
            />
          </div></Paper>
      );
    });
  };

  manage_disabled_position = (stack_length) => {
    //devuelve las posiciones finales que tienen que ser ignoradas para desabilitar los botones
    //el mensaje de inactividad y el de aviso de mensaje largo, no deben ocultar los botones
    //si uno de estos está al final, la función devuelve 1, si están los 2, devuelve un 2, 
    //en caso contrario, 0. 
    //este numero se usa en el render para desabilitar o no los botones de la ultima interacción

    let pos = 0
    if (this.props.messages[stack_length - 1]) {
      if ((this.props.messages[stack_length - 1].text === "¿En qué más te puedo ayudar?") || (this.props.messages[stack_length - 1].type === "warning")) {
        pos = 1
        if (this.props.messages[stack_length - 2]) {
          if ((this.props.messages[stack_length - 2].text === "¿En qué más te puedo ayudar?") || (this.props.messages[stack_length - 2].type === "warning")) {
            pos = 2
          }
        }
      }
    }

    return pos
  }

  handleUser = (isUser, property) => {
    if (isUser) {
      if (property === "colorMensaje") {
        return "#244776";
      } else if (property === "colorTexto") {
        return "white";
      } else if (property === "borderRadiusMensaje") {
        return 0;
      } else if (property === "marginTopMessage") {
        return "-0.4em";
      } else if (property === "alignItems") {
        return "flex-end";
      }
    } else {
      if (property === "colorMensaje") {
        return "#b2c1ce";
      } else if (property === "colorTexto") {
        return "#001C30";
      } else if (property === "borderRadiusMensaje") {
        return 0;
      } else if (property === "borderMensaje") {
        return "1px solid #dee1e5";
      } else if (property === "marginTopMessage") {
        return "1em";
      }
    }
  };

  renderMessage(m) {
    if (m.text) {
      let messages = m.text.split("\n\n");
      const { classes } = this.props;
      return messages.map(msg => {
        return (
          <div key={m.key}>
            <div key={m.key + "_" + m.text} className={classes.messageBlock}>
              {m.isUser ?
                <Avatar alt="Usuario" aria-atomic="false" src={perfil_user} className={classes.perfil} key={m.key + "_avatar_bot"} />
                :
                <Avatar alt="Defensor del Pueblo" aria-atomic="false" src={perfil_bot} className={classes.perfil} key={m.key + "_avatar_user"} />}
              <Paper
                className={classes.messageBubble}
                style={{
                  backgroundColor: m.type === "warning" ? "yellow" : this.handleUser(m.isUser, "colorMensaje"),
                  color: this.handleUser(m.isUser, "colorTexto"),
                  borderRadius: this.handleUser(m.isUser, "borderRadiusMensaje"),
                  border: this.handleUser(m.isUser, "borderMensaje")
                }}
              > <div aria-live="polite" tabIndex="0" role="log">
                  <ReactMarkdown
                    className={classes.messageText}
                    children={msg}
                    components={{
                      a: ({ node, ...props }) => <a {...props} aria-label={node.children[0].value} /> //
                    }}
                  />
                </div>

                <p aria-atomic="false"
                  className={classes.date}
                  style={{ color: this.handleUser(m.isUser, "colorTexto") }}
                >
                  {m.date}
                </p>
              </Paper>
            </div>
          </div>
        );
      });
    } else {
      return null;
    }
  }


  renderNotification(m, index, indexAudio) {
    if (m.reproduced === false) {
      return (
        <audio
          src={m.isUser ? notificacionUser : notificationBot}
          autoPlay={index === indexAudio}
        />)

    }
  }


  renderWriting() {
    if (this.props.is_writing & !this.props.primera_vez) {
      const { classes } = this.props;
      return (
        <div className={classes.messageBlock}>
          <Paper
            className={classes.messageBubbleGenerate}
          >
            <img
              className={classes.generateResponse}
              src={generate_response}
              alt="generando_respuesta"
            />
          </Paper>
        </div>
      );
    }
  }


  render() {
    const { classes } = this.props;
    let counter = 0
    const stack_length = this.props.messages.length;
    let indexAudio = 0;
    for (let i = 0; i < stack_length; i++) {
      indexAudio = i;
    }
    let useless_pos = this.manage_disabled_position(stack_length)

    return (
      <div style={{ flex: 1 }} className={classes.root} >
        {this.props.messages.map((m, index) => {
          m.disabled = (stack_length - 1 - useless_pos === index) ? false : true;
          return (

            <div
              className={classes.fullMessage}
              style={{ alignItems: this.handleUser(m.isUser, "alignItems") }}
              key={m.text + "_" + counter++}
            >
              {this.renderMessage(m)}
              {this.options(m, index) ? (
                <div className={classes.optionsContainer} role="log" aria-live="polite" tabIndex="0">
                  {this.options(m, index)}
                </div>
              ) : null}
              {this.renderNotification(m, index, indexAudio)}
            </div>

          );
        })}

        <div>{this.renderWriting()}</div>
        <div
          ref={el => {
            this.messagesEnd = el;
          }}
        />
      </div>

    );
  }
}

MyList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(autoscroll(MyList));
